import { render, staticRenderFns } from "./mPagination.vue?vue&type=template&id=1e1f394a&scoped=true&"
import script from "./mPagination.vue?vue&type=script&lang=js&"
export * from "./mPagination.vue?vue&type=script&lang=js&"
import style0 from "./mPagination.vue?vue&type=style&index=0&id=1e1f394a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1f394a",
  null
  
)

export default component.exports